module.exports = __webpack_public_path__ + "img/TRACTOR_PGG CHASSIS_RHD.c39f7a03.jpg";